function checkPlatform(): 'ios'| 'android' {
    const agent = navigator.userAgent.toLowerCase();
    if (agent.includes('iphone') || agent.includes('ipad') || agent.includes('ipod')) {
        return 'ios';
    }
    return 'android';
}

function postMessage(methodName: string, ...args: any[]) {
    try {
        const platform = checkPlatform();
        if (platform === 'ios') {
            // @ts-ignore
            window.webkit.messageHandlers[methodName].postMessage(...args);
        } else {
            // @ts-ignore
            window.paperlot[methodName](...args);
        }
    } catch (e) {
        console.warn(`${methodName}은 지원하지 않는 네이티브 기능입니다.`);
    }
}

export function terminateApp() {
    postMessage('terminateApp', '');
}

export function registerToken(userId: string) {
    postMessage('registerToken', userId);
}

export function openExternalLink(url: string) {
    postMessage('openExternalLink', url);
}

export function openInternalLink(url: string) {
    postMessage('openInternalLink', url);
}

export function getAppVersion() {
    postMessage('getVersion', '');
}

export enum Permission {
    NOTIFICATION = 'NOTIFICATION',
    LOCATION ='LOCATION',
    READ_CONTACT = 'READ_CONTACT',
    READ_STORAGE = 'READ_STORAGE'
}

export function checkPermission(permission: Permission) {
    postMessage('checkPermission', permission);
}

export function requestPermission(permission: Permission) {
    postMessage('requestPermission', permission);
}

export function getLocation() {
    postMessage('getLocation', '');
}

export function getAppScheme() {
    postMessage('getAppScheme', '');
}

export function setBarcodeDialogOpen(value: boolean) {
    postMessage('setBarcodeDialogOpen', value);
}

export function getContacts() {
    postMessage('getContacts', '');
}

export function getVersion() {
    postMessage('getVersion', '');
}

export function runVibration() {
    postMessage('runVibration', '');
}

export function requestGoogleSignIn() {
    postMessage('requestGoogleSignin', '');
}
